import {serializable, alias, primitive} from 'serializr';

export class TargetCoverageMeta{

	@serializable
	label?: string;

	@serializable(alias('option', primitive()))
	value?: string;

	@serializable(alias('is_enabled', primitive()))
	disabled?: boolean;

}